import { getHoffmanEnvironment, getWindow } from '../services/windowService';

const { API_GATEWAY_URL, CORE_SERVICE_URL, CDN_URL, UNLEASH_URL, LEGAL_INFORMATION_SERVICE_URL } =
  getHoffmanEnvironment();

export const apiGatewayUrl = API_GATEWAY_URL;
export const coreServiceUrl = CORE_SERVICE_URL || `${apiGatewayUrl}/core-service`;
export const simpleProjectServiceUrl = `${apiGatewayUrl}/project-service`;
export const simpleProjectServicePublicUrl = `${simpleProjectServiceUrl}/public`;
export const partnerInformationUrl = `${apiGatewayUrl}/setting-services-partner-information`;
export const cdnUrl = CDN_URL;
export const configurationUrlBasePath = `${getWindow().location.origin}/configurator`;
export const unleashUrl =
  UNLEASH_URL || `${apiGatewayUrl}/project-service/public/api/unleash/proxy`;
export const legalInformationServiceUrl = LEGAL_INFORMATION_SERVICE_URL;
